import React, { useState } from "react";
import { Button, Card, Col, Container, Form, Image, Row, Stack } from "react-bootstrap";
import { Loader } from "../components/common/Loader";
import InputField from "../components/common/InputField";
import { errorAlert, successAlert } from "../components/common/Alert";
import { Link, useNavigate } from "react-router-dom";
import { forgotPassword } from "../services/Networkcall";
 

export const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [error, setError] = useState({ "email": "" });
    const [loading, setLoading] = useState(false);

    const inputHandler = (e) => {
        const { name, value } = e.target;
        setEmail(value);
        setError((pre) => ({ ...pre, [name]: "" }));
    }

    const submitHandler = async (e) => {

        e.preventDefault();

        let isValid = 1;

        if (!email) {
            setError((prev) => ({ ...prev, email: "Email is required *" }));
            isValid = 2;
        } else if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(email)) {
            setError((prev) => ({ ...prev, email: "Invalid email format *" }));
            isValid = 3;
        }


        if (isValid === 1) {
            setLoading(true);
            const data = { "email": email }
            try {

                const res = await forgotPassword(data);

                if (res.success) {
                    successAlert({ message: res?.message});
                    navigate("/login");
                } else {
                    errorAlert({ message: res.message });
                }
            } catch (err) {
                errorAlert({ message: err?.response?.data?.message || err?.message || "something went wrong" })
            } finally {
                setLoading(false);
            }
        }
    }

    return (
        <>
            <div className="login-wrapper">
                <Loader show={loading} />
                <Card className="login-card">
                    <div className="login-header">
                        <h3 className="mb-0">TruckTuck <span className="mb-1">PRO</span></h3>
                        <h6 className="mb-0 fw-bold mt-3">Forgot Password</h6>
                    </div>

                    <Form onSubmit={submitHandler}>
                        <Stack gap={3} direction="vertical">

                            <InputField
                                label={'Email'}
                                type="email"
                                name={'email'}
                                placeholder="Enter email"
                                value={email}
                                required={true}
                                onChange={inputHandler}
                                error={error.email}
                            />

                            <Button type="submit" className="login-btn w-100 mt-2 ">
                                Send
                            </Button>
                            <Link to={'/login'} className="text-center small text-decoration-none cursor-pointer"> ← Back to Login</Link>
                        </Stack>
                    </Form>
                </Card>

            </div>
        </>

    );
};
